// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-container {
  min-height: calc(100vh - 24px);
}

.no-map-controls .leaflet-container {
  min-height: calc(100vh - 24px);
}

.geofence-modal {
  height: 100%;
}
.geofence-modal .leaflet-container {
  min-height: 360px;
  height: 100%;
}
.geofence-modal .leaflet-top {
  color: #333;
}

.driver-page-content .maparea2 {
  height: 100%;
}
.driver-page-content .leaflet-container {
  min-height: 100%;
  height: calc(100vh - 48px - 10px - 49px) !important;
}

/* 
.shown-widgets {
	.leaflet-container {
		//min-height: calc(100% - 36px - 150px)
	}	
} */
.with-timeline .leaflet-container {
  min-height: calc(100vh - 24px - 81px);
  height: auto !important;
}
.with-timeline.rows-shown-10 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 10 - 24px);
}
.with-timeline.rows-shown-9 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 9 - 24px);
}
.with-timeline.rows-shown-8 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 8 - 24px);
}
.with-timeline.rows-shown-7 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 7 - 24px);
}
.with-timeline.rows-shown-6 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 6 - 24px);
}
.with-timeline.rows-shown-5 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 5 - 24px);
}
.with-timeline.rows-shown-4 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 4 - 24px);
}
.with-timeline.rows-shown-3 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 3 - 24px);
}
.with-timeline.rows-shown-2 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 2 - 24px);
}
.with-timeline.rows-shown-1 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 1 - 24px);
}
.with-timeline.rows-shown-0 .leaflet-container {
  min-height: calc(100vh - 50px - 48px - 30px * 0 - 24px);
}
.with-timeline .leaflet-popup-content {
  min-width: 180px;
}
.with-timeline .vis-labelset {
  min-width: 150px;
}
.with-timeline .vis-custom-time {
  z-index: 999;
}
.with-timeline .vis-custom-time {
  width: 4px;
}
.with-timeline .speed-slider {
  background: #fff;
  width: 110px;
  position: absolute;
  bottom: 10px;
  left: 10px;
  padding: 5px 10px;
  color: #4d4d4d;
  z-index: 9999;
  border: 2px solid rgba(0, 0, 0, 0.25);
  background-clip: padding-box;
  border-radius: 4px;
}
.with-timeline .speed-slider label {
  font-size: 12px;
}
.with-timeline .speed-slider .slider {
  max-height: 20px;
  top: -15px;
}

.no-widgets .leaflet-container {
  min-height: calc(100vh - 24px);
}

.checkbox {
  cursor: pointer;
}

@media (max-width: 1499px) {
  .leaflet-container {
    min-height: calc(100vh - 24px);
  }
  .custom-map-notification {
    min-height: 100%;
  }
}
.custom-map-notification {
  min-height: 100%;
}

@media (max-width: 479px) {
  .leaflet-container {
    min-height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Monitoring/Style.scss"],"names":[],"mappings":"AACA;EACE,8BAAA;AAAF;;AAGE;EACE,8BAAA;AAAJ;;AAIA;EACE,YAAA;AADF;AAEE;EACE,iBAAA;EACA,YAAA;AAAJ;AAEE;EACE,WAAA;AAAJ;;AAIE;EACE,YAAA;AADJ;AAGE;EACE,gBAAA;EACA,mDAAA;AADJ;;AAIA;;;;;GAAA;AAQE;EACE,qCAAA;EACA,uBAAA;AAHJ;AAQM;EACE,wDAAA;AANR;AAKM;EACE,uDAAA;AAHR;AAEM;EACE,uDAAA;AAAR;AADM;EACE,uDAAA;AAGR;AAJM;EACE,uDAAA;AAMR;AAPM;EACE,uDAAA;AASR;AAVM;EACE,uDAAA;AAYR;AAbM;EACE,uDAAA;AAeR;AAhBM;EACE,uDAAA;AAkBR;AAnBM;EACE,uDAAA;AAqBR;AAtBM;EACE,uDAAA;AAwBR;AAbE;EACE,gBAAA;AAeJ;AAZE;EACE,gBAAA;AAcJ;AAXE;EACE,YAAA;AAaJ;AAXE;EACE,UAAA;AAaJ;AATE;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,qCAAA;EACA,4BAAA;EACA,kBAAA;AAWJ;AAVI;EACE,eAAA;AAYN;AAVI;EACE,gBAAA;EACA,UAAA;AAYN;;AAPE;EACE,8BAAA;AAUJ;;AAPA;EACE,eAAA;AAUF;;AANA;EACE;IACE,8BAAA;EASF;EAPA;IACE,gBAAA;EASF;AACF;AAPA;EACE,gBAAA;AASF;;AAPA;EACE;IACE,gBAAA;EAUF;AACF","sourcesContent":["@import '../../assets/variables';\n.leaflet-container {\n  min-height: calc(100vh - #{$footerHeight});\n}\n.no-map-controls {\n  .leaflet-container {\n    min-height: calc(100vh - #{$footerHeight});\n  }\n}\n\n.geofence-modal {\n  height: 100%;\n  .leaflet-container {\n    min-height: 360px;\n    height: 100%;\n  }\n  .leaflet-top {\n    color: #333;\n  }\n}\n.driver-page-content {\n  .maparea2 {\n    height: 100%;\n  }\n  .leaflet-container {\n    min-height: 100%;\n    height: calc(100vh - #{$footerHeight * 2} - 10px - #{$topGap}) !important;\n  }\n}\n/* \n.shown-widgets {\n\t.leaflet-container {\n\t\t//min-height: calc(100% - #{$mapFiltersHeight} - #{$mapWidgetsHeight})\n\t}\t\n} */\n\n.with-timeline {\n  .leaflet-container {\n    min-height: calc(100vh - #{$footerHeight} - 81px);\n    height: auto !important;\n  }\n\n  @for $i from 10 through 0 {\n    &.rows-shown-#{$i} {\n      .leaflet-container {\n        min-height: calc(\n          100vh -\n            50px - \n            48px -\n            (30px * #{$i}) -\n            #{$footerHeight}\n        );\n      }\n    }\n  }\n\n  .leaflet-popup-content {\n    min-width: 180px;\n  }\n\n  .vis-labelset {\n    min-width: 150px;\n  }\n\n  .vis-custom-time {\n    z-index: 999;\n  }\n  .vis-custom-time {\n    width: 4px;\n    //background: #999;\n  }\n\n  .speed-slider {\n    background: #fff;\n    width: 110px;\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    padding: 5px 10px;\n    color: #4d4d4d;\n    z-index: 9999;\n    border: 2px solid rgba(0, 0, 0, 0.25);\n    background-clip: padding-box;\n    border-radius: 4px;\n    label {\n      font-size: 12px;\n    }\n    .slider {\n      max-height: 20px;\n      top: -15px;\n    }\n  }\n}\n.no-widgets {\n  .leaflet-container {\n    min-height: calc(100vh - #{$footerHeight});\n  }\n}\n.checkbox {\n  cursor: pointer;\n}\n\n// responsive\n@media (max-width: 1499px) {\n  .leaflet-container {\n    min-height: calc(100vh - #{$footerHeight});\n  }\n  .custom-map-notification {\n    min-height: 100%;\n  }\n}\n.custom-map-notification {\n  min-height: 100%;\n}\n@media (max-width: 479px) {\n  .leaflet-container {\n    min-height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
